import { jsx, jsxs } from "react/jsx-runtime";
import { SvgIcon } from "@mui/material";
const st0 = { fill: "#fff" };
function WorkWaveLogoStackedContrast(props) {
  const { width = "100%", sx = {}, ...rest } = props;
  return /* @__PURE__ */ jsxs(
    SvgIcon,
    {
      "data-testid": "workWaveLogo",
      titleAccess: "WorkWave Logo",
      viewBox: "0 0 521.41 316.36",
      sx: { ...sx, height: "auto", width },
      ...rest,
      children: [
        /* @__PURE__ */ jsx(
          "path",
          {
            style: st0,
            d: "M519.4 259.9c0 3.3-2.5 5.8-5.8 5.8-3.2 0-5.8-2.6-5.8-5.8 0-3.2 2.6-5.8 5.8-5.8 3.3 0 5.8 2.6 5.8 5.8zm-10.7 0c0 2.9 2.1 5.1 4.9 5.1 2.8 0 4.8-2.3 4.8-5.1 0-2.9-2-5.2-4.8-5.2s-4.9 2.4-4.9 5.2zm4 3h-1.3v-5.8c.5-.1 1.2-.2 2.2-.2 1.1 0 1.5.2 2 .4.3.2.6.7.6 1.3 0 .6-.5 1.1-1.2 1.3v.1c.6.2.9.6 1 1.4.2.9.3 1.2.4 1.4H515c-.2-.2-.3-.7-.4-1.4-.1-.6-.4-.9-1.2-.9h-.6v2.4zm0-3.3h.6c.7 0 1.3-.2 1.3-.8 0-.5-.4-.9-1.2-.9-.3 0-.6 0-.7.1v1.6z"
          }
        ),
        /* @__PURE__ */ jsx("g", { id: "XMLID_1219_", children: /* @__PURE__ */ jsxs("g", { id: "XMLID_1220_", children: [
          /* @__PURE__ */ jsx(
            "path",
            {
              id: "XMLID_1234_",
              style: st0,
              d: "M66.2 256.3c-2.3 0-4.4 1.5-5.1 3.7l-10.3 32.1-9.2-32.1c-.6-2.1-2.7-3.7-4.9-3.7s-4.2 1.5-4.8 3.7l-9.2 32-10.4-32c-.7-2.1-2.7-3.7-5.1-3.7-2.9 0-5.3 2.4-5.3 5.3 0 2.4 14 44.3 15.7 49.5.7 2.1 2.7 3.7 5.1 3.7 2.3 0 4.5-1.5 5.1-3.7l9-31.4 9 31.4c.6 2.2 2.7 3.7 5 3.7s4.4-1.5 5.1-3.7c1.7-5.2 15.7-47.1 15.7-49.5-.1-2.9-2.5-5.3-5.4-5.3"
            }
          ),
          /* @__PURE__ */ jsx(
            "path",
            {
              id: "XMLID_1233_",
              style: st0,
              d: "m241.5 278.7 13.5-13.3c1-1 1.6-2.3 1.6-3.8 0-2.9-2.4-5.3-5.3-5.3-1.4 0-2.7.6-3.7 1.5l-24.8 24.3V262c0-3.1-2.5-5.7-5.7-5.7s-5.7 2.6-5.7 5.7v47c0 3.2 2.6 5.7 5.7 5.7 3.2 0 5.7-2.7 5.7-5.7v-12c3.6-3.6 7.3-7.1 10.9-10.7l16.1 26c.9 1.5 2.7 2.6 4.5 2.6 2.9 0 5.2-2.4 5.2-5.3 0-.9-.3-1.9-.8-2.7l-17.2-28.2z"
            }
          ),
          /* @__PURE__ */ jsx(
            "path",
            {
              id: "XMLID_1232_",
              style: st0,
              d: "M334.5 256.3c-2.3 0-4.4 1.5-5.1 3.7l-10.3 32.1L310 260c-.6-2.1-2.7-3.7-4.9-3.7s-4.2 1.5-4.8 3.7l-9.2 32-10.4-32c-.7-2.1-2.7-3.7-5.1-3.7-2.9 0-5.3 2.4-5.3 5.3 0 2.4 14 44.3 15.7 49.5.7 2.1 2.7 3.7 5.1 3.7 2.3 0 4.5-1.5 5.1-3.7l9-31.4 9 31.4c.6 2.2 2.7 3.7 5 3.7s4.4-1.5 5.1-3.7c1.7-5.2 15.7-47.1 15.7-49.5-.1-2.9-2.5-5.3-5.5-5.3"
            }
          ),
          /* @__PURE__ */ jsx(
            "path",
            {
              id: "XMLID_1231_",
              style: st0,
              d: "M443.1 256.3c-2.1 0-3.9 1.2-4.8 3.1l-16 38.3-15.9-38.3c-.8-2-2.8-3.1-4.9-3.1-2.8 0-5.2 2.6-5.2 5.4 0 .7.2 1.5.4 2.1l20.8 47.9c.9 2 2.7 3.1 4.9 3.1 2.1 0 4-1.2 4.8-3.1l20.7-47.9c.3-.7.5-1.5.5-2.2 0-2.9-2.4-5.3-5.3-5.3"
            }
          ),
          /* @__PURE__ */ jsx(
            "path",
            {
              id: "XMLID_1230_",
              style: st0,
              d: "M499.5 303.4h-26.7v-12.7h14.1c2.9 0 5.3-2.3 5.3-5.3s-2.4-5.4-5.3-5.4h-14.1v-12.3h25.4c2.9 0 5.4-2.4 5.4-5.4 0-2.9-2.5-5.3-5.4-5.3h-31.1c-3.2 0-5.7 2.5-5.7 5.7v45.7c0 3.2 2.6 5.7 5.7 5.7h32.4c2.9 0 5.4-2.3 5.4-5.3 0-2.9-2.5-5.4-5.4-5.4"
            }
          ),
          /* @__PURE__ */ jsx(
            "path",
            {
              id: "XMLID_1227_",
              style: st0,
              d: "M108.4 256c-16.4 0-29.3 13.1-29.3 29.6s12.9 29.7 29.3 29.7 29.2-13.2 29.2-29.7c0-16.4-12.8-29.6-29.2-29.6m0 48.7c-10.7 0-17.9-8.6-17.9-19.1 0-10.5 7.2-19 17.9-19s17.8 8.5 17.8 19-7.1 19.1-17.8 19.1"
            }
          ),
          /* @__PURE__ */ jsx(
            "path",
            {
              id: "XMLID_1224_",
              style: st0,
              d: "M197.8 274.2c0-12.5-9.5-17.1-20.8-17.1h-21.2c-3.2 0-5.7 2.5-5.7 5.7v46.4c0 3.2 2.5 5.7 5.7 5.7 3.1 0 5.7-2.5 5.7-5.7v-18.1h15.7c.1.4 9.3 18.9 10.2 20.7.9 1.9 2.8 3.1 4.9 3.1 3.1 0 5.6-2.5 5.6-5.5 0-2.7-7.7-17-9.3-20.2 6.1-2.7 9.2-8.3 9.2-15m-19.2 7.1h-17.1v-13.7h17.1c4.3 0 7.8 2.4 7.8 6.9 0 4.6-3.6 6.8-7.8 6.8"
            }
          ),
          /* @__PURE__ */ jsx(
            "path",
            {
              id: "XMLID_1221_",
              style: st0,
              d: "M342.1 307.3c-.3.7-.4 1.5-.4 2.2 0 2.9 2.3 5.3 5.2 5.3 1.2 0 2.4-.4 3.3-1.3.6-.4 1.1-1 1.4-1.7.3-.7 7.4-14.8 26.7-16.9l7.6 16.8c.9 1.9 2.7 3.1 4.8 3.1 3 0 5.4-2.5 5.4-5.4 0-.7-.2-1.5-.5-2.1l-21.9-47.9c-.8-1.8-2.7-3.1-4.7-3.1-2.1 0-4 1.1-5 3.1l-21.9 47.9zm32.2-21.4c-5 .8-9.3 2.3-13 4.2l7.6-16.4 5.4 12.2z"
            }
          )
        ] }) }),
        /* @__PURE__ */ jsxs("g", { id: "w-circle_32_", children: [
          /* @__PURE__ */ jsx(
            "path",
            {
              style: st0,
              d: "M260.5.8C195 .9 141.9 54.1 142 119.7c.1 65.5 53.3 118.6 118.9 118.5 65.5-.1 118.6-53.3 118.5-118.9C379.3 53.7 326 .7 260.5.8zm-106.2 108c.9-4.6 5.4-7.5 10-6.6 4.6.9 7.5 5.4 6.6 10-.9 4.6-5.4 7.5-9.9 6.6-4.7-1-7.7-5.5-6.7-10zm6.3 28.1-.8-2.9c-.2-.5-.3-1-.4-1.5-1.1-5.3 2.3-10.6 7.6-11.7 5.3-1.1 10.6 2.3 11.7 7.6l.8 2.9c.2.5.3 1 .4 1.5 1.1 5.3-2.3 10.6-7.6 11.7-5.4 1.1-10.6-2.3-11.7-7.6zm32.3 21.6-2.7 6c-2.3 5-8.2 7.1-13.2 4.8-4.8-2.3-7-7.9-4.9-12.8l3.1-6.9c2.2-5 8-7.2 13-5 5.1 2.2 6.9 9 4.7 13.9zm110.5 27.6s-2.9 6.5-9.9 6.1c-3.9 0-7.5-2.5-8.9-6.1l-22.8-69-23.8 56.6c-1.2 2.7-3.5 4.8-6.4 5.6-5.4 1.7-11.2-1.4-12.9-6.8l-14-42.4-2.2 5.5c-.4.9-1 1.8-1.6 2.6-2.9 3.3-7.5 4.4-11.5 2.6-5-2.2-7.3-8.1-5-13.1l.4-.9L196.4 96c2.3-5.2 8.4-7.5 13.6-5.2 2.4 1.1 4.3 3.1 5.3 5.5l.1.4 5.2 15.4 1 2.9c0 .1.1.1.1.2l.1.2 8 23.4 23.5-56.1c2.3-5.2 8.4-7.5 13.6-5.2 2.9 1.3 5 3.9 5.8 7l5.4 16.7.4 1.4c0 .1.1.1.1.2l-.2-.8.1.2c.7 1.7 16.3 49.6 16.3 49.6l36.9-87.5s5.1-8.9 13.4-4.9c8.3 4.1 5.6 12.5 5.6 12.5l-47.3 114.2z"
            }
          ),
          /* @__PURE__ */ jsxs(
            "linearGradient",
            {
              id: "_Path_9_1_",
              gradientUnits: "userSpaceOnUse",
              x1: 210.551,
              y1: -824.081,
              x2: 198.036,
              y2: -817.143,
              gradientTransform: "matrix(1 0 0 -1 0 -684.965)",
              children: [
                /* @__PURE__ */ jsx("stop", { offset: 0, stopColor: "#4d4a4a", stopOpacity: 0 }),
                /* @__PURE__ */ jsx("stop", { offset: 1, stopColor: "#221f1f" })
              ]
            }
          ),
          /* @__PURE__ */ jsx(
            "path",
            {
              id: "_Path_9_78_",
              d: "m229.9 138.8-8-23.4-.1-.2c-.9-2.4-3.3-4.9-6.6-3.9-2.7.8-4.1 3.4-4.7 4.8l-5.7 14 14 42.5c1.7 5.4 7.5 8.5 12.9 6.8 2.8-.9 5.2-2.9 6.4-5.6l2.1-5.1-10.3-29.9z",
              opacity: 0.7,
              fill: "url(#_Path_9_1_)"
            }
          ),
          /* @__PURE__ */ jsxs(
            "linearGradient",
            {
              id: "_Path_10_1_",
              gradientUnits: "userSpaceOnUse",
              x1: 263.684,
              y1: -819.601,
              x2: 243.131,
              y2: -808.2,
              gradientTransform: "matrix(1 0 0 -1 0 -684.965)",
              children: [
                /* @__PURE__ */ jsx("stop", { offset: 0, stopColor: "#231f20", stopOpacity: 0 }),
                /* @__PURE__ */ jsx("stop", { offset: 0.02, stopColor: "#231f20", stopOpacity: 0.04 }),
                /* @__PURE__ */ jsx("stop", { offset: 0.19, stopColor: "#231f20", stopOpacity: 0.31 }),
                /* @__PURE__ */ jsx("stop", { offset: 0.36, stopColor: "#231f20", stopOpacity: 0.53 }),
                /* @__PURE__ */ jsx("stop", { offset: 0.53, stopColor: "#231f20", stopOpacity: 0.71 }),
                /* @__PURE__ */ jsx("stop", { offset: 0.69, stopColor: "#231f20", stopOpacity: 0.83 }),
                /* @__PURE__ */ jsx("stop", { offset: 0.851, stopColor: "#231f20", stopOpacity: 0.9 }),
                /* @__PURE__ */ jsx("stop", { offset: 1, stopColor: "#231f20", stopOpacity: 0.93 })
              ]
            }
          ),
          /* @__PURE__ */ jsx(
            "path",
            {
              id: "_Path_10_78_",
              d: "m295 151.7-2.7-8.3-13.4-40.6c-.8-2.5-3.2-5.1-6.7-4.1-2.7.8-4.1 3.4-4.7 4.8l-5.7 13.5v.1l22.8 69c1.5 3.7 5 6.1 8.9 6.1 7 .3 9.9-6.1 9.9-6.1l1.6-3.8-10-30.6z",
              opacity: 0.7,
              fill: "url(#_Path_10_1_)"
            }
          )
        ] })
      ]
    }
  );
}
export {
  WorkWaveLogoStackedContrast
};
//# sourceMappingURL=WorkWaveLogoStackedContrast.js.map
